import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import {Check} from 'react-feather';


class AccountForm extends Component{
  constructor() {
    super();
    this.state = {
      isUpdated: false,
      showDelete: false,
      email: '',
      telephone: '',
    }
  }

  getUser = () => {
    let headers = {"Content-Type": "application/json"};
    const token = this.props.token
    if (token) {
      headers["Authorization"] = `Token ${token}`;
      fetch("/api/users", {headers, })
        .then(res => {
          if (res.status === 200) {
            res.json()
            .then(user => this.setState({...user}))
            .catch(error => console.log(res))
          } else {
            console.log("Server Error!");
            throw res;
          }
        })
      }
  }

  updateUser = (event) => {
    event.preventDefault()
    let _this = this
    const token = this.props.token
    let body = JSON.stringify({...this.state});
    let headers = { "Content-Type": "application/json", };
    if (token) {
      headers["Authorization"] = `Token ${token}`;
      fetch("/api/users", {headers, body, method: "POST"})
        .then(res => {
          if (res.status === 200) {
            _this.setState({isUpdated: true})
          } else if (res.status === 400) {
            _this.setState({
              isUpdated: false,
              error: "Det finns redan ett vinabonnemang med den här emailadressen"
            })
          } else {
            console.log("Server Error!");
            throw res;
          }
        })
    }
  }

  toggleShowDelete = (event) => {
    event.preventDefault()
    this.setState(prevState => ({showDelete: !prevState.showDelete}))
  }

  deleteUser = () => {
    this.props.deleteUser()
  }

  handleInputChange = (event) => {
    const value = event.target.value;
    const name = event.target.name;

    this.setState({
      [name]: value
    });
  }


  componentDidMount() {
    this.getUser()
  }

  render() {
    return(
      <div className="AccountForm">
        {
          this.state.showDelete
          ?
          <div className="Account-form-overlay">
            <div className="Account-form-popup">
              <p>
                Är du säker på att du vill avsluta ditt vinabonnemang?<br/>
                Uppsägningen av ditt vinabonnemang gäller från och med näskommande månad.
                Önskar du omedelbar uppsägning maila oss på info@escapat.com
              </p>
              <button
                className="Account-button signout"
                onClick={this.deleteUser}>
                Avsluta
              </button>
              <button
                className="Account-button"
                onClick={this.toggleShowDelete}>
                Avbryt
              </button>
            </div>
          </div>
          :
          null
        }
        <h1 className="m-b-10">Konto</h1>
        <form className="Account-form" onSubmit={this.updateUser}>
          <div className="Account-form-nested">
            {
              this.state.isUpdated
              ?
              <div className="Account-updated">
                <Check />
                <p>Dina uppgifter har uppdateras</p>
              </div>
              :
              <div className="Account-updated">
                <p className="error">{this.state.error}</p>
              </div>
            }
            
            <div className="form-section">
              <label className="Account-label">Emailadress</label>
              <input className="Account-input"
                name="email"
                type='email'
                value={this.state.email}
                onChange={this.handleInputChange}
                />
            </div>            
            <div className="form-section">
              <label className="Account-label">Telefonnummer</label>
              <input className="Account-input"
                name="telephone"
                type='tel'
                value={this.state.telephone}
                onChange={this.handleInputChange}
                />
            </div>
            <div className="form-section">
              <button className="Account-button">
                Spara
              </button>
            </div>
            <div className="form-section">
              <button onClick={this.props.toggleSignOut}
                className="Account-button signout">
                Logga ut
              </button>
            </div>
            <div className="form-section">
              <button onClick={this.toggleShowDelete}
                className="Account-button signout">
                Avsluta vinabonnemang
              </button>
            </div>
          </div>
        </form>
      </div>
    )
  }
}

export default AccountForm;



// WEBPACK FOOTER //
// ./src/components/AccountForm.jsx